import { IDirectUpload } from "config";
import { apolloClient } from "config/apollo";
import { gql } from "config/graphql";

export interface ICreateDirectUploadToCloudInput {
  byteSize: number;
  checksum: string;
  contentType: string;
  filename: string;
}

interface ICreateDirectUploadToCloudPayload {
  createDirectUploadToCloud: {
    directUpload: IDirectUpload;
  };
}

export const createDirectUploadToCloudMutation = (input: ICreateDirectUploadToCloudInput) => {
  const mutation = gql`
    mutation CreateDirectUploadToCloud($input: CreateDirectUploadToCloudInput!) {
      createDirectUploadToCloud(input: $input) {
        directUpload {
          blobId
          headers
          signedBlobId
          url
        }
      }
    }
  `;

  return apolloClient.mutate<ICreateDirectUploadToCloudPayload>({
    variables: { input },
    mutation,
  });
};
